import { GlassCard } from "features/option-controls/glass-option-controls/components/GlassCard";
import { useGlassHelper } from "features/option-controls/helpers/useGlassHelper";
import { OptionTemplate } from "shared/api/middleware-api-client";
import { SlidesLayout } from "./SlidesLayout";

export const GlassSelector = () => {
  const {
    doorOptionsLoading,
    doorOptionsLoadError,
    doorOptions,
    selectedDoor,
    color,
    glassCategories,
    onUpdateGlass,
  } = useGlassHelper();

  if (doorOptionsLoading) return <div>Loading...</div>;
  if (doorOptionsLoadError) return <div>Error!</div>;
  if (!selectedDoor || !doorOptions || !color) return null;

  return (
    <SlidesLayout>
      <div className="gg-flex gg-w-full gg-flex-col gg-space-y-6">
        {glassCategories.map((category, id) => (
          <div key={category.title} className="">
            <div className="gg-px-3.5">
              <h5 className="gg-text-sm gg-font-semibold gg-text-dark-blue">
                {category.title}
              </h5>

              <p className="gg-mt-1.5 gg-text-xs gg-text-purple-300">
                {category.description}
              </p>
            </div>

            <div className="gg-mt-3 gg-grid gg-h-full gg-w-full gg-grid-cols-3 gg-place-items-center gg-items-start gg-gap-x-3 gg-gap-y-1.5">
              {category.items.map((glass: OptionTemplate, id) => {
                return (
                  <GlassCard
                    key={id}
                    glass={glass}
                    updateGlass={onUpdateGlass}
                    selectedDoor={selectedDoor}
                  />
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </SlidesLayout>
  );
};
